import LabLogin from "components/mnl/lab/labAuth/labLogin";

const LabLoginPage = () => {
  return <LabLogin />;
};

export default LabLoginPage;
